<div class="flex flex-col">
    <span class="text-2xl">Uploaded Files</span>
    <app-grid-toolbar
        [gridApi]="gridApi"
        [options]="gridToolbarOptions"
    ></app-grid-toolbar>
    <ag-grid-angular
        class="ag-theme-quartz h-96"
        [context]="context"
        [rowData]="rowData"
        [columnDefs]="columnDefs"
        [gridOptions]="gridOptions"
        (gridReady)="onGridReady($event)"
        overlayNoRowsTemplate="No files presently uploaded"
    >
    </ag-grid-angular>
</div>
